const CONTACT_SUPPORT_TEXT = 'Please contact Wood Mackenzie Supply Chain support.';

//

export function createRequestErrorMessage(message = '', response = {}) {
  const errorMessage = message ? `${message}.` : '';
  const errorCode = response?.data?.referenceCode ? `Error code: ${response.data.referenceCode}` : '';

  return [errorMessage, CONTACT_SUPPORT_TEXT, errorCode].filter(v => v).join(' ');
}
